import PerfectScrollbar from "perfect-scrollbar";

require('./bootstrap');
require('bootstrap-autocomplete');

let MapBoxGl = require('mapbox-gl/dist/mapbox-gl.js');
let clusterContainer = $('#image-clusters-container');
let tsnejs = require('./lib/tsne');
let d3 = require('d3');
let IIIF_ROOT = $('meta[name=img_root_url]').attr("content");
let VOYAGE_DATA_FILEMTIME = $('meta[name=voyage_data_filemtime]').attr("content");
let BASE_IMAGE_SIZE = window.innerWidth / 30;
let images = [], distanceMatrix = [];
let theme = $('.map-theme').data('theme');

let zoom;
let loadedPoint;
let loadedArrow;

$(document).ready(function () {

    if($('#click-to-scroll').length) {
        document.getElementById("click-to-scroll").click();
    }

    /* Search */
    $("#search-field").autoComplete({
    	minLength: 1,
    	noResultsText: '',
        resolverSettings: {
            url: '/auto_complete',
        }
    });

    $("#search-field").on('autocomplete.select', function(event, item) {
    	window.location.href = '/search?keyword=' + item.text + '&wikidataId=' + item.value;
    });
    $("#search-field").on('autocomplete.freevalue', function(event, item) {
    	window.location.href = '/search?keyword=' + item;
    });

    let annotationId;

    $('body').on('click', '#image-details .related', function () {
        let type = $(this).data('type');
        let id = $(this).data('id');
        if (type === 'image') {
            getImageData(id);
        }
        if(type === 'annotation') {
            getAnnotationData(id);
        }
    });

    $('.search-action').on('click', function(){
        window.location.href = '/search?keyword=' + $('#search-field').val();
    })

    $('.arrow-hide-left-bar').on('click', function(){
        $('body').toggleClass('hide-archives-bar');
    });

    $('.year-toggle').on('click', function(){
        if(!$(this).parent().hasClass('rotate-arrow')){
            $('.rotate-arrow').removeClass('rotate-arrow');
            $(this).closest('.year').toggleClass('rotate-arrow');
            $(".show").removeClass("show");

            // let top = $(this).position().top;
            // $(this).scrollTop(top - 465);
        }else{
            $('.rotate-arrow').removeClass('rotate-arrow');
        }
    });

    $('.archive-text').on('click', '.editButton', function(){
        let transcription = $($(this)).closest('.transcription').find('.transcription-text').html();
        let inputField = $('#annotationSuggestionField');
        inputField.val(transcription.trim());
        annotationId = $(this).data('annotation_id');

        $('#annotationSuggestionModal').modal('toggle');

    })

    $('#annotationSuggestionModal').on('click', '.submitSuggestion', function(){
        let inputField = $('#annotationSuggestionField');
        $.ajax({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            url: '/annotations/' + annotationId + '/suggestion',
            data: { suggestion:inputField.val() },
            type: 'POST',
            success: function() {
                $('#annotationSuggestionModal').modal('toggle');
            }
        });
    })

    $(document).on('click', '#image-results div.image-result', function() {
	    let image_id = $(this).data('image_id');
	    getImageData(image_id);
	    $('#mapMarkerModal').modal('show');
	});
    
    $(document).on('click', '#annotation-results img', function(){
        getAnnotationData($(this).data('id'));
        $('#mapMarkerModal').modal('show');
    });
    
    $(document).on('click', 'div#image-cluster-info', function() {
	    $('#image-cluster-info-modal').modal('show');
	});
    
    $('#image-cluster-info-modal').on('hidden.bs.modal', function (e) {
    	document.cookie = "ImageClusterInfoModalShown=true; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/";
    })

    if(clusterContainer.length) {
    	if (document.cookie.indexOf("ImageClusterInfoModalShown=true") < 0) {
    		$('#image-cluster-info-modal').modal('show');
    	}
    	
        $.getJSON('../image_clusters/' + theme + '/images.json', function(data){
            data.forEach(function(image) {
                images.push(image)
            });

            $.getJSON('../image_clusters/' + theme + '/distanceMatrix.json', function(data){
                data.forEach(function(distance) {
                    distanceMatrix.push(distance)
                });

                let zoom = d3.zoom()
                    .scaleExtent([0.5, 20])
                    .on('zoom', zoomed);

                let svg = d3.select('#image-clusters-container').append('svg')
                    .attr('width', '100%')
                    .attr('height', '100%')
                    .attr('xmlns:xlink', 'http://www.w3.org/1999/xlink')
                    .attr('xmlns', 'http://www.w3.org/2000/svg')
                    .call(zoom);

                let image_size = BASE_IMAGE_SIZE / Math.sqrt((images.length + 1) / 100);

                let centerX = d3.scaleLinear().range([image_size, clusterContainer.width() - image_size]);
                let centerY = d3.scaleLinear().range([image_size, clusterContainer.height() - image_size]);

                let tsne = new tsnejs.tSNE({
                    dim: 2,
                    perplexity: 10,
                    epsilon: 3
                });

                tsne.initDataRaw(distanceMatrix);
                tsne.iter = 0;

                let nodes = svg.append('g').attr('class', 'nodes');
                let node = nodes.selectAll('.node').data(images, function(d) {
                    return d.image_id;
                });
                node.exit().remove();

                let selectedImage = null;
                node = node.enter().append('g')
                    .attr('class', 'node')
                    .on('click', function(d) {
                        selectImage(d);
                        getImageData(d.image_id);
                        let markerModal = $('#mapMarkerModal');
                        markerModal.modal('show');
                        markerModal.on('hidden.bs.modal', function(e) {
                        	selectImage(null); // Deselect the image
                        })
                    })
                    .merge(node);

                node.append('image').merge(node)
                    .attr('xlink:href', function(d) {
                        return IIIF_ROOT + d.iiif_path;
                    })
                    .attr('x', -image_size / 2)
                    .attr('y', -image_size / 2)
                    .attr('width', image_size)
                    .attr('height', image_size)
                    .attr('data-id', function(d) {
                        return d.image_id;
                    });

                node.append('circle')
                    .attr('r', image_size * Math.sqrt(2) / 2)
                    .attr('stroke', '#14BA5C')
                    .attr('stroke-width', 3)
                    .attr('fill-opacity', 0)
                    .attr('visibility', 'hidden');

                let simulation = d3.forceSimulation().force('tsne', function (alpha) {
                    // every time you call this, solution gets better
                    tsne.step();

                    // 'coordinates' is an array of 2-D points that you can plot
                    let coordinates = tsne.getSolution();
                    if (coordinates && images) {

                        centerX.domain(d3.extent(coordinates.map(function (d) {
                            return d[0];
                        })));
                        centerY.domain(d3.extent(coordinates.map(function (d) {
                            return d[1];
                        })));

                        images.forEach(function (d, i) {
                            if (!d.x) {
                                d.x = 0;
                            }
                            if (!d.y) {
                                d.y = 0;
                            }
                            d.x += alpha * (centerX(coordinates[i][0]) - d.x);
                            d.y += alpha * (centerY(coordinates[i][1]) - d.y);
                        });
                    }
                })
                    .force('collide',
                        d3.forceCollide().radius(function(d) {
                            return image_size / 2 * 1.2;
                        })
                    )
                    .on('tick', ticked);

                //Duration to run the simulation (1 minute).

                let endTime = new Date().getTime() + 60000;

                simulation.nodes(images);
                simulation.alphaDecay(0.0001).alpha(0.02).restart();

                // Zoom in/out with buttons.

                d3.select('#zoom-in').on('click', function() { zoom.scaleBy(svg, 1.2); });
                d3.select('#zoom-out').on('click', function() { zoom.scaleBy(svg, 0.8); });
                d3.select('#zoom-fit').on('click', function() { zoom.scaleTo(svg, 1); });
                d3.select(window).on('resize', restart);

                function zoomed() {
                    nodes.attr('transform', d3.event.transform);
                }

                function ticked() {
                    node.attr('transform', function(d) {
                        if(!isNaN(d.x) && !isNaN(d.y)) {
                            return 'translate(' + d.x.toFixed(20) + ',' + d.y.toFixed(20) + ')';
                        }
                    });

                    if (new Date().getTime() >= endTime) {
                        simulation.stop();
                    }
                }

                function restart() {
                    BASE_IMAGE_SIZE = window.innerWidth / 30;
                    image_size = BASE_IMAGE_SIZE / Math.sqrt((images.length + 1) / 100);

                    centerX = d3.scaleLinear().range([0, clusterContainer.width()]);
                    centerY = d3.scaleLinear().range([0, clusterContainer.height()]);

                    nodes.selectAll('image')
                        .attr('x', -image_size / 2)
                        .attr('y', -image_size / 2)
                        .attr('width', image_size)
                        .attr('height', image_size);

                    node.selectAll('circle')
                        .attr('r', image_size * Math.sqrt(2) / 2);

                    endTime = new Date().getTime() + 15000;
                    simulation.alphaDecay(0.0001).alpha(0.02).restart();
                }

                function selectImage(argSelectedImage) {
                    nodes.selectAll('circle').attr('visibility', function(d) {
                        return (argSelectedImage != null && argSelectedImage.image_id === d.image_id) ? 'visible' : 'hidden';
                    });
                }
            });
        });
    }

    function getImageData(imageId) {
        $.ajax({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            url: '/images/' + imageId,
            data: {
                ajax: true,
                is_expo: $('body').hasClass('expo')
            },
            type: 'GET',
            success: function(response) {
            	$('#mapMarkerModal #image-details').replaceWith(response.data);
            	$('#mapMarkerTitle').html(response.title);
            	$('.image-date').html(response.date).show();
            	
            	// Wait until the image is loaded so that the loader can be displayed in the meantime.
                var img = new Image();
            	img.onload = function() {
        			$('#main-image-wrapper').html('<img src="' + response.imageUrl + '" id="main-image" alt="' + response.title + '" >');
            	}

            	img.src = response.imageUrl;
            	if (img.complete) {
            		img.onload();
            	}
            }
        });
    }

    function getAnnotationData(annotationId) {
        $.ajax({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            url: '/annotation/' + annotationId,
            data: {
                ajax: true,
                is_expo: $('body').hasClass('expo')
            },
            type: 'GET',
            beforeSend: function() {
            	$('.image-date').hide();
            },
            success: function(response) {
            	$('#mapMarkerModal #image-details').replaceWith(response.data);
            	$('#mapMarkerTitle').html(response.title);
            	
                // Wait until the image is loaded so that the loader can be displayed in the meantime.
                var img = new Image();
            	img.onload = function() {
        			$('#main-image-wrapper').html('<img src="' + response.imageUrl + '" id="main-image">');
            	}

            	img.src = response.imageUrl;
            	if (img.complete) {
            		img.onload();
            	}
            }
        });
    }

    var voyage1 = ['==', ['get', 'voyage_id'], 'Q91094170'];
    var voyage2 = ['==', ['get', 'voyage_id'], 'Q4558367'];
    var voyage3 = ['==', ['get', 'voyage_id'], 'Q3563351'];
    var voyage4 = ['==', ['get', 'voyage_id'], 'Q3533809'];
    var voyage5 = ['==', ['get', 'voyage_id'], 'Q8132166'];
    var others = ['==', ['get', 'voyage_id'], 'others'];
    var isClusterClickable = true;
    
    // colors to use for the categories
    var colors = ['#FF595E', '#FFCA3A', '#8AC926', '#1982C4', '#6A4C93', '#6c757d'];

    // MapBox
    if($('#map').length) {
        MapBoxGl.accessToken = 'pk.eyJ1IjoiY3lib3IiLCJhIjoiY2toMXBrcjljMGE0dDJ4bmFhaWlyeDVoMCJ9.ypEFPoy1F20Wxk6f-VeNpw';
        let map = new MapBoxGl.Map({
            container: 'map',
            style: 'mapbox://styles/cybor/ckl8650np6pqc17tbl8i4o6fl?optimize=true',
            attributionControl: false,
            minZoom: 2,
            maxZoom: 15,
            boxZoom: false,
            doubleClickZoom: false,
            dragRotate: false,
            keyboard: false,
            pitchWithRotate: false,
            touchPitch: false,
        });
        
        $.getJSON('../voyageData.json?' + VOYAGE_DATA_FILEMTIME, function(data) {
        	map.fitBounds([
        		[parseInt(data.minBound[0]) - 5, data.minBound[1]],
        		[parseInt(data.maxBound[0]) + 5, data.maxBound[1]]
    		]);
            
            map.on('load', () => {
                // add a clustered GeoJSON source for locations
                map.addSource('locations', {
                    'type': 'geojson',
                    'data': data.featureCollection,
                    'cluster': true,
                    'clusterRadius': 40,
                    'clusterMaxZoom': 14,
                    'clusterProperties': {
                        // keep separate counts for each magnitude category in a cluster
                        'voyage1': ['+', ['case', voyage1, ["get", "image_count"], 0]],
                        'voyage2': ['+', ['case', voyage2, ["get", "image_count"], 0]],
                        'voyage3': ['+', ['case', voyage3, ["get", "image_count"], 0]],
                        'voyage4': ['+', ['case', voyage4, ["get", "image_count"], 0]],
                        'voyage5': ['+', ['case', voyage5, ["get", "image_count"], 0]],
                        'others': ['+', ['case', others, ["get", "image_count"], 0]],
                    }
                });
                
                // This is a hack to "cluster" custom HTML markers.
                map.addLayer({
                    id: "clusters",
                    type: "circle",
                    source: "locations",
                    filter: ["has", "point_count"],
                    paint: {
                    	// Use step expressions (https://docs.mapbox.com/mapbox-gl-js/style-spec/#expressions-step)
                    	// with 4 steps to implement 4 types of circles:
                    	//   * 14px circles when point count is less than 10
                    	//   * 20px circles when point count is less between 11 and 100
                    	//   * 28px circles when point count is less between 101 and 1000
                    	//   * 40px circles when point count is greater than or equal to 1001
                    	'circle-color': '#fff',
                    	'circle-opacity': 0,
                    	'circle-radius': [
	                    	'step',
	                    	['get', 'point_count'],
	                    	14,
	                    	11,
	                    	20,
	                    	101,
	                    	28,
	                    	1001,
	                    	40
                    	]
                    }
                });
                
                map.addLayer({
                    id: 'unclustered-location',
                    type: 'circle',
                    source: 'locations',
                    'filter': ['!=', 'cluster', true],
                    'paint': {
                        'circle-color': [
                            'case',
                            voyage1,
                            colors[0],
                            voyage2,
                            colors[1],
                            voyage3,
                            colors[2],
                            voyage4,
                            colors[3],
                            voyage5,
                            colors[4],
                            colors[5]
                        ],
                        'circle-radius': 12,
                    },
                });
                map.addLayer({
                	'id': 'unclustered-location-label',
                	'type': 'symbol',
                	'source': 'locations',
                	'filter': ['!=', 'cluster', true],
                	'layout': {
                		'text-field': ['get', 'image_count'],
        				'text-font': ['Open Sans Semibold', 'Arial Unicode MS Bold'],
        				'text-size': 10
                	},
                	'paint': {
                		'text-color': 'white'
                	}
            	});

                // objects for caching and keeping track of HTML marker objects (for performance)
                var markers = {};
                var markersOnScreen = {};

                function updateMarkers() {
                    var newMarkers = {};
                    var features = map.querySourceFeatures('locations');
                    
                    // for every cluster on the screen, create an HTML marker for it (if we didn't yet),
                    // and add it to the map if it's not there already
                    for (var i = 0; i < features.length; i++) {
                        var coords = features[i].geometry.coordinates;
                        var props = features[i].properties;
                        if (!props.cluster) continue;
                        var id = props.cluster_id;
                        
                        var marker = markers[id];
                        if (!marker) {
                            var el = createDonutChart(props);
                            
                            marker = markers[id] = new MapBoxGl.Marker({
                                element: el
                            }).setLngLat(coords);
                        }
                        newMarkers[id] = marker;
                        
                        if (!markersOnScreen[id]) marker.addTo(map);
                    }

                    // for every marker we've added previously, remove those that are no longer visible
                    for (id in markersOnScreen) {
                        if (!newMarkers[id]) markersOnScreen[id].remove();
                    }
                    markersOnScreen = newMarkers;
                    
                    isClusterClickable = true;
                }

                // after the GeoJSON data is loaded, update markers on the screen and do so on every map move/moveend
                map.on('data', function (e) {
                    if (e.sourceId !== 'locations' || !e.isSourceLoaded) return;
                    
                    map.on('render', updateMarkers);
                    updateMarkers();
                });

                // inspect a unclustered location on click
                map.on('click', 'unclustered-location', function (e) {
                	getImages(e.features[0].properties['image_ids'], 0);
                    $('#mapMarkerModal').modal('show');
                });
                
                // inspect a cluster on click
                map.on('click', 'clusters', function (e) {
                	if(isClusterClickable) {
                		isClusterClickable = false;
                		
	                	var features = map.queryRenderedFeatures(e.point, { layers: ['clusters'] });
						var clusterId = features[0].properties.cluster_id;
						
						map.getSource('locations').getClusterExpansionZoom(clusterId, function (err, zoom) {
							if (err) return;
							
							map.easeTo({
			                    center: features[0].geometry.coordinates,
			                    zoom: Math.max(zoom, map.getZoom() + 4)
		                    });
	                    });
                	}
                });
                
                // Adding a control button to set the map back to a home.
                class HomeControl {
            		onAdd(map) {
	                    var button = document.createElement("button");
	                    button.className = "mapboxgl-ctrl-icon mapboxgl-ctrl-home";
	                    button.type = "button";
	                    button["aria-label"] = "Toggle Pitch";
	                    button.onclick = function() {
	                    	map.easeTo({zoom: 1, center: [0, 0]});
	                    	map.fitBounds([
	                    		[parseInt(data.minBound[0]) - 5, data.minBound[1]],
	                    		[parseInt(data.maxBound[0]) + 5, data.maxBound[1]]
	                		]);
	                    }
                    
	                    this.map = map;
	                    this.container = document.createElement('div');
	                    this.container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group';
	                    this.container.appendChild(button);
	                    
	                    return this.container;
        			}
            		onRemove(){
            			this.container.parentNode.removeChild(this.container);
            			this.map = undefined;
            		}
                }

                const homeControl = new HomeControl();

                map.addControl(homeControl, 'top-left');
                map.addControl(new MapBoxGl.NavigationControl({showCompass: false}), 'top-left');
            });
        })
    }

    // code for creating an SVG donut chart from feature properties
    function createDonutChart(props) {
        var offsets = [];
        var counts = [
            props.voyage1,
            props.voyage2,
            props.voyage3,
            props.voyage4,
            props.voyage5,
            props.others
        ];
        var total = 0;
        for (var i = 0; i < counts.length; i++) {
            offsets.push(total);
            total += counts[i];
        }
        var fontSize = total >= 1000 ? 16 : total >= 100 ? 16 : total >= 10 ? 14 : 12;
        var r = total >= 1000 ? 40 : total >= 100 ? 28 : total >= 10 ? 20 : 14;
        var r0 = Math.round(r * 0.6);
        var w = r * 2;

        var html =
            '<div id="clusters"><svg width="' +
            w +
            '" height="' +
            w +
            '" viewbox="0 0 ' +
            w +
            ' ' +
            w +
            '" text-anchor="middle" style="font: ' +
            fontSize +
            'px sans-serif; display: block">';

        for (i = 0; i < counts.length; i++) {
            html += donutSegment(
                offsets[i] / total,
                (offsets[i] + counts[i]) / total,
                r,
                r0,
                colors[i]
            );
        }
        html +=
            '<circle cx="' +
            r +
            '" cy="' +
            r +
            '" r="' +
            r0 +
            '" fill="white" /><text dominant-baseline="central" transform="translate(' +
            r +
            ', ' +
            r +
            ')">' +
            total.toLocaleString() +
            '</text></svg></div>';

        var el = document.createElement('div');
        el.innerHTML = html;
        return el.firstChild;
    }

    function donutSegment(start, end, r, r0, color) {
        if (end - start === 1) end -= 0.00001;
        var a0 = 2 * Math.PI * (start - 0.25);
        var a1 = 2 * Math.PI * (end - 0.25);
        var x0 = Math.cos(a0),
            y0 = Math.sin(a0);
        var x1 = Math.cos(a1),
            y1 = Math.sin(a1);
        var largeArc = end - start > 0.5 ? 1 : 0;

        return [
            '<path d="M',
            r + r0 * x0,
            r + r0 * y0,
            'L',
            r + r * x0,
            r + r * y0,
            'A',
            r,
            r,
            0,
            largeArc,
            1,
            r + r * x1,
            r + r * y1,
            'L',
            r + r0 * x1,
            r + r0 * y1,
            'A',
            r0,
            r0,
            0,
            largeArc,
            0,
            r + r0 * x0,
            r + r0 * y0,
            '" fill="' + color + '" />'
        ].join(' ');
    }

    $('#mapMarkerModal').on('hidden.bs.modal', function (e) {
    	$(this).find('#mapMarkerTitle').html('');
    	$(this).find('.modal-title.image-date').html('').hide();
    	$(this).find('#imageAnnotations').empty();
    	$(this).find('#relations').empty();
    	$(this).find('#main-image-tags').empty();
    	$(this).find('#main-image-wrapper').html('<div class="position-absolute" style="top: 50%; left: 50%; transform: translate(-50%, -50%)"><div class="spinner-border" role="status" style="color: #a16d31"></div></div>');
    })
})

window.moreResults = function(wikidataId, keyword, type, page) {
	if (typeof page === 'undefined') {
		window.location.href = '/search?keyword=' + keyword + '&wikidataId=' + wikidataId + '&type=' + type + '&page=1';
	} else {
		page++;

		$.ajax({
	        url: '/search?keyword=' + keyword + '&wikidataId=' + wikidataId + '&type=' + type + '&page=' + page,
	        success: function(response) {
	        	$('.search-results #more-results').remove();
	            $('.search-results').append(response);
	        }
	    });
	}
}

window.getImages = function(strImageIds, index) {
	$.ajax({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        url: '/multipleImages',
        data: {
        	ajax: true,
        	image_ids: strImageIds,
        	index: index,
        	is_expo: $('body').hasClass('expo')
    	},
        type: 'POST',
        success: function(response) {
        	$('#mapMarkerModal #image-details').replaceWith(response.data);
        	$('#mapMarkerTitle').html(response.title);
        	$('.image-date').html(response.date).show();
        	
        	// Wait until the image is loaded so that the loader can be displayed in the meantime.
            var img = new Image();
        	img.onload = function() {
    			$('#main-image-wrapper').html('<img src="' + response.imageUrl + '" id="main-image" alt="' + response.title + '" >');
        	}

        	img.src = response.imageUrl;
        	if (img.complete) {
        		img.onload();
        	}
        }
	});
}
